<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-2">
          <p class="mb-0 font-weight-bold">Camera:
            <a-select v-model="camera" class="ml-2">
              <a-select-option
                v-for="device in devices"
                :key="device.deviceId"
                :value="device.deviceId"
              >
                {{ device.label }}
              </a-select-option>
            </a-select>
          </p>

        </div>
        <!-- <p class="font-weight-bold text-muted">Current Camera:
          <code v-if="device" class="ml-3 text-primary">{{ device.label }}</code>
        </p> -->
        <div class="border rounded pt-2 p-md-2" style="background:#000;">
          <vue-web-cam
            ref="webcam"
            :device-id="deviceId"
            width="100%"
            :height="this.settings['isMobileView'] ? 150 : 300"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
        </div>

        <div class="row mt-3">
          <div class="col-md-12 mb-3">
            <div class="btn-group" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-primary" @click="onCapture">
                <i class="mr-2 fe fe-circle" /> Capture
              </button>
              <button type="button" class="btn btn-danger" @click="onStop">
                <i class="mr-2 fe fe-camera-off" /> Stop
              </button>
              <button type="button" class="btn btn-success" @click="onStart">
                <i class="mr-2 fe fe-camera" /> Start
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div>
          <p class="font-weight-bold">Student Photo:</p>
            <div class="">
              <neo-photo-view :image="img" :student="data" @updated="handlePhotoUpdate"/>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { WebCam } from 'vue-web-cam'
import PhotoView from './PhotoView'

export default {
  props: ['data'],
  components: {
    'vue-web-cam': WebCam,
    'neo-photo-view': PhotoView,
  },
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
    }
  },
  computed: {
    ...mapState(['settings']),
    device: function() {
      return this.devices.find(n => n.deviceId === this.deviceId)
    },
  },
  watch: {
    camera: function(id) {
      this.deviceId = id
    },
    devices: function() {
      // Once we have a list select the first one
      // eslint-disable-next-line no-unused-vars
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture()
    },
    onStarted(stream) {
      // console.log('On Started Event', stream)
    },
    onStopped(stream) {
      // console.log('On Stopped Event', stream)
    },
    onStop() {
      this.$refs.webcam.stop()
    },
    onStart() {
      this.$refs.webcam.start()
    },
    onError(error) {
      console.log('On Error Event', error)
    },
    onCameras(cameras) {
      this.devices = cameras
      // console.log('On Cameras Event', cameras)
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      // console.log('On Camera Change Event', deviceId)
    },
    handlePhotoUpdate() {
      this.$emit('updated')
      this.img = null
    },
  },

}
</script>
